import {useSessionStorage} from '@vueuse/core'
import {v4 as uuidv4} from 'uuid'


export const session = useSessionStorage(
    'sourceRef',
    uuidv4()
)